import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import globalMethods from "./methods";

Vue.config.productionTip = false;

Vue.mixin({
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  methods: globalMethods,
});

window.app = new (Vue.extend(App))({
  router,
  store,
  vuetify,
}).$mount("#app");
